import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-laboratory-pathology',
  templateUrl: './laboratory-pathology.component.html',
  styleUrls: ['./laboratory-pathology.component.css']
})
export class LaboratoryPathologyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
